import React, { useEffect, useState } from "react";
import imageSrc from "./img/pc.jpg";
import styles from "./contact-us.scss";
import StaticPage from "../static-page/static-page";
import { getLocalStorage } from '@tw/shared-ui-components/lib/utils/helper';

export default function ContactUs() {
  const [showChatBotButton, setShowChatBotButton] = useState(false);
  const adaChatBot = getLocalStorage("adaChatBot");
  useEffect(() => {
    if (adaChatBot !== undefined && adaChatBot !== "undefined" && adaChatBot !== null && adaChatBot !== 'null' && Object.keys(adaChatBot).length > 0) {
      setShowChatBotButton(adaChatBot?.enabled)
    }
  }, [Object.keys(adaChatBot).length])
  const bindToggleShowChatBot = () => {
    window.adaEmbed.toggle()
  }
  return (
    <StaticPage>
      <div className={styles["main_div"]}>
        <div className={styles["text1"]}>
          <h3></h3>
        </div>

        <div>
          <img src={imageSrc} />
        </div>
        <div className={styles["text2"]}>
          <p></p>
          <b>聯繫我們</b>
        </div>
        <div className={styles["text"]}>
          <ul>
            <li>
              智能客服：
              {
                showChatBotButton ? <a href="javascript:void(0);" onClick={bindToggleShowChatBot}>
                  點此
                </a> : <a href="https://care.amway.com.tw/live800/chatClient/chatbox.jsp?companyID=9058&configID=3&enterurl=Hybris&lan=zh_TW">
                  點此
                </a>
              }
              即時互動諮詢
            </li>
            <li>
              客服專線：(02)2175-5166
              <br /> 時間：週一~週五 8:30~18:00 (國定假日除外)
            </li>
          </ul>
        </div>
      </div>
    </StaticPage>
  );
}
